import {LangObject} from "@brg/api/dist/api-core/utils/lang-utils";
import {createDefaultLangObject} from "../../components/__ADDONS__/__SAFEAPI__/Defaults";
import {Tag} from "@brg/api";

const normalizeLang = (value?: string) => (value ?? '').toLowerCase().trim();

export const setProjectTitleByLang = (
    isBilingual: boolean,
    currentTitle: LangObject[] = [],
    lang: string,
    value: string
): LangObject[] => {

    if (isBilingual) {
        const targetLang = normalizeLang(lang) === 'ru' ? 'ru' : 'en';

        const ruValue =
            currentTitle.find((item) => normalizeLang(item?.lang) === 'ru') ??
            { lang: 'Ru', name: '' };
        const enValue =
            currentTitle.find((item) => normalizeLang(item?.lang) === 'en') ??
            { lang: 'En', name: '' };

        if (targetLang === 'ru') {
            return [
                { ...ruValue, lang: 'Ru', name: value },
                { ...enValue, lang: 'En' },
            ];
        }

        return [
            { ...ruValue, lang: 'Ru' },
            { ...enValue, lang: 'En', name: value },
        ];
    } else {
        return createDefaultLangObject(value);
    }
}

export const splitTags = (tags: Tag[]) => {
    return tags.reduce((acc, tag) => {
        const entity =
            tag?.entityTypes?.includes('places')
                ? 'places' : tag?.entityTypes?.includes('cities')
                    ? 'cities' : tag?.entityTypes?.includes('required_category')
                        ? 'required_category' : tag?.entityTypes?.includes('onlines_required_category')
                            ? 'onlines_required_category'
                            : 'tags';
        return {
            ...acc,
            [entity]: [...acc[entity], tag],
        }
    }, {
        cities: [],
        tags: [],
        places: [],
        onlines_required_category: [],
        required_category: []
    })
}import {LangObject} from "@brg/api/dist/api-core/utils/lang-utils";
import {createDefaultLangObject} from "../../components/__ADDONS__/__SAFEAPI__/Defaults";
import {Tag} from "@brg/api";

const normalizeLang = (value?: string) => (value ?? '').toLowerCase().trim();

export const setProjectTitleByLang = (
    isBilingual: boolean,
    currentTitle: LangObject[] = [],
    lang: string,
    value: string
): LangObject[] => {

    if (isBilingual) {
        const targetLang = normalizeLang(lang) === 'ru' ? 'ru' : 'en';

        const ruValue =
            currentTitle.find((item) => normalizeLang(item?.lang) === 'ru') ??
            { lang: 'Ru', name: '' };
        const enValue =
            currentTitle.find((item) => normalizeLang(item?.lang) === 'en') ??
            { lang: 'En', name: '' };

        if (targetLang === 'ru') {
            return [
                { ...ruValue, lang: 'Ru', name: value },
                { ...enValue, lang: 'En' },
            ];
        }

        return [
            { ...ruValue, lang: 'Ru' },
            { ...enValue, lang: 'En', name: value },
        ];
    } else {
        return createDefaultLangObject(value);
    }
}

export const splitTags = (tags: Tag[]) => {
    return tags.reduce((acc, tag) => {
        const entity =
            tag?.entityTypes?.includes('places')
                ? 'places' : tag?.entityTypes?.includes('cities')
                    ? 'cities' : tag?.entityTypes?.includes('required_category')
                        ? 'required_category' : tag?.entityTypes?.includes('onlines_required_category')
                            ? 'onlines_required_category'
                            : 'tags';
        return {
            ...acc,
            [entity]: [...acc[entity], tag],
        }
    }, {
        cities: [],
        tags: [],
        places: [],
        onlines_required_category: [],
        required_category: []
    })
}